module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bbrbbr.length !== 0) ? _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_schankverlust_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Bierranking " + _vm._s(_vm.$filters.date(_vm.date, "MM.YY")))])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.statistik), function(item, index) {
    return _c('tr', {
      key: item[0],
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showBbr = true)
        }
      }
    }, [(index === 0) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "amber--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 1) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text lighten-1"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index === 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', {
      staticClass: "deep-orange--text darken-3"
    }, [_vm._v("emoji_events")])], 1) : _vm._e(), _vm._v(" "), (index > 2) ? _c('td', {
      attrs: {
        "width": "30px"
      }
    }, [_c('v-icon', [_vm._v("military_tech")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item[0], _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item[1]))])])
  }), 0)])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bdf5882"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/bierranking.vue
// module id = 748
// module chunks = 15